import { hdrm } from '@yola/ws-sdk';
import handleOptions from './handle-options';
import restoreOptions from '../layout-switching/restore-options';
import { WHITESPACE_TOP, WHITESPACE_BOTTOM } from '../../constants/display-options';
import { LIVE_PREVIEW_MOCKED_ID } from '../../constants/common';
import { stripHiddenClassTokens } from '../hidden-class-tokens';

const compileLivePreviewNode = ({
  optionalChildren,
  sortBlockVariationId,
  selectedLayoutVariationId,
  displayOptions,
  selectedPreviewNode,
}) => {
  const isSelectedDefaultState =
    sortBlockVariationId === LIVE_PREVIEW_MOCKED_ID &&
    selectedLayoutVariationId === LIVE_PREVIEW_MOCKED_ID;

  const destinationBlockNode = selectedPreviewNode;

  if (isSelectedDefaultState) {
    (optionalChildren || []).forEach((item) => {
      hdrm.helpers.updateChildrenPresence(
        destinationBlockNode,
        item.querySelector,
        item.isEnabled,
        item.id
      );
    });
    handleOptions(destinationBlockNode, displayOptions);
  } else {
    restoreOptions(destinationBlockNode, [WHITESPACE_TOP, WHITESPACE_BOTTOM]);
  }

  const previewNode = destinationBlockNode.cloneNode(true);
  // If the block is hidden and the user opens Block Settings → Switch layout,
  // the default thumbnail is cloned from the static node, which still has hidden
  // classes. Without stripping them the preview would render empty.
  previewNode.setAttribute(
    'class',
    stripHiddenClassTokens(previewNode.getAttribute('class') || '')
  );

  return previewNode;
};

export default compileLivePreviewNode;
